export default "__VITE_ASSET__CRk0ddf1__"